module.exports = __webpack_public_path__ + "static/media/U1-T1-08B_R.809fd4bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T1-08B_R.svg
// module id = 585
// module chunks = 0